import { COLORS } from '../theme';

const isBankruptcyStatus = (statusDescription: string | null | undefined) =>
  !!statusDescription && statusDescription.toLowerCase().includes('bankruptcy');

export const getColorForCompanyStatus = (
  status: string | null,
  companyId: string | null,
  statusDescription?: string | null,
) => {
  if (!status && !companyId) {
    return COLORS.lightGray;
  }

  if (status?.toLowerCase() === 'active') {
    return COLORS.lightGreen;
  }

  if (isBankruptcyStatus(statusDescription)) {
    return COLORS.lightRed;
  }

  return COLORS.lightYellow;
};

export const getLabelForCompanyStatus = (params: {
  status: string | null;
  companyId: string | null;
  statusDescription: string | null;
  activeLabel: string;
  draftLabel: string;
  unknownLabel: string;
}) => {
  if (!params.status && !params.companyId) {
    return params.draftLabel;
  }
  return params.status?.toLowerCase() === 'active' ? params.activeLabel : params.statusDescription ?? params.unknownLabel;
};
